module.exports = "<div>\n  <ins class=\"adsbygoogle\"\n     style=\"display:block\"\n     data-ad-client=\"ca-pub-6662392421938729\"\n     data-ad-slot=\"6478353696\"\n     data-ad-format=\"auto\"></ins>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/ad/ad.component.html
// module id = ../../../../../src/app/shared/ad/ad.component.html
// module chunks = 4